import {Button, Col, Row, Spinner} from "reactstrap";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {useEffect, useState} from "react";
import RequestUserSettingsModel from "../Model/Request/RequestUserSettingsModel";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import ResponseUserSettingsModel from "../Model/Response/ResponseUserSettingsModel";
import $ from "jquery";
import {useTranslation} from "react-i18next";
import i18next from "i18next";
import {LoadLocalStorage} from "../../Common/Helpers/LoadLocalStorage";
import i18n from "i18next";
import Select from 'react-select';
import { InfoPageMessage } from "../../Common/Components/Button/InfoPageMessage";
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";
import { CustomModal } from "../../Common/Components/Modal/CustomModal";
import { QRCode } from 'react-qr-code';
import { useSelector } from "react-redux";
import axios from 'axios';
import { API_URL, PUBLIC_PATHS } from "../../config";
import InformationSignalR from "../../AppSystem/Helpers/InformationSignalR";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";


export function UserSetting() {
    const { t } = useTranslation();

    useEffect(() => {
        if (i18next.language !== LoadLocalStorage('selectedLanguage')){
            i18n.changeLanguage(LoadLocalStorage('selectedLanguage'));
        }
    }, []);
    const {userData, tokenData} = useSelector(state => state.auth);
    const {ApiCall} = useApiCallService();
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('userSetting.settings'));
        setPageTitleKey('userSetting.settings');
        setOnBack(null);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    // REQUESTS
    const [requestUserSettings, setRequestUserSettings] = useState(new RequestUserSettingsModel());

    // API RESPONSES
    const [responseUserSettings, setResponseUserSettings] = useState(new ResponseUserSettingsModel());

    //GET USER SETTING
    const [done, setDone] = useState(false);

    //MODALS
    const [displaySendModal, setDisplaySendModal] = useState(false);
    const [displaySendQrModal, setDisplaySendQrModal] = useState(false);
    const [displaySendRedirectModal, setDisplaySendRedirectModal] = useState(false);
    const [displaySpinner, setDisplaySpinner] = useState(false);
    const [displayBeforeShowQrCode, setDisplayBeforeShowQrCode] = useState(false);

    const [responseQr, setResponseQr] = useState('');
    const [isQrResponseError, setIsQrResponseError] = useState(false);

    //EDIT MODE
    const [editModeSettings, setEditModeSettings] = useState(false);
    const [checkClickButton, setCheckClickButton] = useState(false);

    // VALIDATION ACCOUNT NUMBER OPEN PAYMENT
    const [showSignButton, setShowSignButton] = useState(false);
    const [showDropdownBank, setShowDropdownBank] = useState(false);
    const [showEnterManually, setShowEnterManually] = useState(false);
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [showImgBank, setShowImgBank] = useState(false);
    const [imgBank, setImgBank] = useState(false);
    const [bankValue, setBankValue] = useState('');
    const [consentResponse, setConsentResponse] = useState('');

    const [banks, setBanks] = useState([]);
    const [bankOptions, setBankOptions] = useState([]);

    const [loading, setLoading] = useState(false);
    const [bankIdMessage, setBankIdMessage] = useState(false);

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
     
    // VALIDATION SCHEMAS
    const completeSchemaUserSetting = RequestUserSettingsModel.getAttributes( null, true);

    const clearingNumberInput = document.getElementById('clearingNumber');
    if (clearingNumberInput) {
        clearingNumberInput.addEventListener('keypress', function (e) {
            const key = e.key;
            
            if (key < '0' || key > '9') {
                e.preventDefault();
                return;
            }

            const currentValue = clearingNumberInput.value;
            const newValue = currentValue + key;
            const digitsOnly = newValue.replace(/[^0-9]/g, '');
            
            const maxLength = (digitsOnly[0] === '8') ? 5 : 4;

            if (digitsOnly.length > maxLength) {
                e.preventDefault();
            }
        });
    }


    const accountNumberInput = document.getElementById('accountNumber');
    if (accountNumberInput) {
        accountNumberInput.addEventListener('keypress', function (e) {
            const key = e.key;
            const currentValue = accountNumberInput.value;

            const isValidChar = (key >= '0' && key <= '9')/* || key === '.' || key === ','*/;
            const hasReachedMaxLength = currentValue.replace(/[^0-9]/g, '').length >= 12;

            if (!isValidChar || hasReachedMaxLength) {
                e.preventDefault();
            }

        });
    }
    const favoriteBanks = ['Swedbank', 'Länsförsäkringar AB', 'Handelsbanken'];
    const customBankNames = {
        'Nordea Bank AB': 'Nordea',
        'Danske Bank A/S': 'Danske Bank',
        'Skandinaviska Enskilda Banken AB': 'SEB',
        'Länsförsäkringar AB': 'Länsförsäkringar',
        'Skandiabanken AB': 'Skandiabanken',
    };

    //GET BANKS LIST
    useEffect(() => {
            // const handleBankListResponse = (response) => {
            //     if (response) {
            //         const filteredBanks = response.aspsps.filter((bank) => bank.bicFi !== "DNBASESX");
            //         setBanks(filteredBanks);
            //         const options = filteredBanks.map((bank) => ({
            //         value: bank.bicFi,
            //         label: bank.name,
            //         }));

            //         const favorites = favoriteBanks.map(name =>
            //             options.find(opt => opt.label.toLowerCase() === name.toLowerCase())
            //         ).filter(Boolean);

            //         const others = options
            //             .filter(opt =>
            //             !favoriteBanks.some(fav =>
            //                 fav.toLowerCase() === opt.label.toLowerCase()
            //             )
            //             )
            //             .sort((a, b) => a.label.localeCompare(b.label));

            //         const groupedOptions = [
            //             { label: '', options: favorites, customIndex: 0 },
            //             { label: '', options: others, customIndex: 1 },
            //         ];
            //         setBankOptions(groupedOptions);
            //     }
            // };

            const handleBankListResponse = (response) => {
                if (response) {
                    const excludedBics = ["DNBASESX", "SPSDSE23"];
                    const filteredBanks = response.aspsps.filter((bank) => !excludedBics.includes(bank.bicFi));
                    setBanks(filteredBanks);

                    const options = filteredBanks.map((bank) => {
                        const originalName = bank.name;
                        const displayName = customBankNames[originalName] || originalName;

                        return {
                            value: bank.bicFi,
                            label: displayName,
                            originalLabel: originalName
                        };
                    });

                    const favorites = favoriteBanks.map(name =>
                        options.find(opt => opt.originalLabel.toLowerCase() === name.toLowerCase())
                    ).filter(Boolean);

                    const others = options
                        .filter(opt =>
                            !favoriteBanks.some(fav =>
                                fav.toLowerCase() === opt.originalLabel.toLowerCase()
                            )
                        )
                        .sort((a, b) => a.label.localeCompare(b.label));

                    const groupedOptions = [
                        { label: '', options: favorites, customIndex: 0 },
                        { label: '', options: others, customIndex: 1 },
                    ];

                    setBankOptions(groupedOptions);
                }
            };

            const CostApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/open-payment/aspsp-list",
                    };
                    await ApiCall(apiCallOptions, handleBankListResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            if(userData.pnr !== null){
                CostApiCall();
            }
            
    }, []);

    const SubmitSettings = async () => {
        try {
            await completeSchemaUserSetting.validate(requestUserSettings, { abortEarly: false });
            $('#submitUserSettings').prop('disabled', true);

            if (requestUserSettings.accountNumber !== "") {
                const apiCallOptions = {
                    method: "post",
                    url: "/usersetting/bank-account",
                    data: requestUserSettings,
                };
                try {
                    await ApiCall(apiCallOptions, setResponseUserSettings);
                    FlashMessage(  t('validationMessage.bankAccountSave'), 'flash-messageSuccess');
                } catch (error) {
                    console.log(error);
                     FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };


    const HandleChange = (e, name) => {
        let value = e.target.value;
        setRequestUserSettings((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }


    //Edit
    const EditSettings = async () => {
        try {
            await completeSchemaUserSetting.validate(requestUserSettings, { abortEarly: false });
            $('#editUserSettings').prop('disabled', true);

            if (requestUserSettings.accountNumber !== "") {
                const apiCallOptions = {
                    method: "put",
                    url: "/usersetting/bank-account",
                    data: requestUserSettings,
                };
                try {
                    await ApiCall(apiCallOptions, setResponseUserSettings);

                } catch (error) {
                    console.log(error);
                    FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };


    const [hasLoadedUserSettings, setHasLoadedUserSettings] = useState(false);
    //GET USER SETTING
    useEffect(() => {
        if(responseUserSettings !== null && responseUserSettings.clearingNumber === '' && !hasLoadedUserSettings){
            const handleUserSettingsResponse = (responseUserSettings) => {
                if(responseUserSettings !== null) {
                    setSpinnerLoading(false);
                    setResponseUserSettings(responseUserSettings);  
                    setHasLoadedUserSettings(true);                  
                }
            };

            const CostApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/usersetting/bank-account",
                    };
                    await ApiCall(apiCallOptions, handleUserSettingsResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            CostApiCall();
        }
    }, [responseUserSettings,hasLoadedUserSettings]);


    useEffect(() => {
        if(responseUserSettings === null) {
            FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
        }
        if(responseUserSettings !== null && responseUserSettings.clearingNumber !== '' && checkClickButton === true) {
            setDone(true);
        }
        //setShowDropdownBank(false);
    }, [responseUserSettings]);


    useEffect(() => {
        if (done === true) {
            FlashMessage(  t('validationMessage.bankAccountUpdate'), 'flash-messageSuccess');
            setEditModeSettings(false);
            setDone(false);
            $('#editUserSettings').prop('disabled', false);
        }
    }, [done]);


    useEffect(() => {

        let intervalId;
        let timeoutId;
        setLoading(false); 
        if(consentResponse === null) {
            FlashMessage(t('validationMessage.opError'), 'flash-messageError');
        }     
        
        if (typeof consentResponse === 'string' && consentResponse.trim() !== '') {
            if(consentResponse.startsWith('bankid') || consentResponse.startsWith('https://app.bankid.com')) {
                if (isMobile) {
                    setResponseQr(consentResponse);
                    setDisplaySendQrModal(true);
                    // intervalId = setInterval(() => {
                    //     fetchNewQr();
                    // }, 600);
                    fetchNewQr();
                } else {
                    setDisplaySendQrModal(true);
                    setResponseQr(consentResponse);
                    
                    intervalId = setInterval(() => {
                        fetchNewQr();
                    }, 600);

                    // timeoutId = setTimeout(() => {
                    //     CustomReload();
                    //     setDisplaySendQrModal(false);
                    //     clearInterval(intervalId);
                    // }, 30000); 
                    }
                
            }
            else{
                setDisplaySendRedirectModal(true);
            }
            
        }
        return () => {
        if (intervalId) clearInterval(intervalId);
        clearTimeout(timeoutId);
        };

    }, [consentResponse]);

    const fetchNewQr = async () => {
        try {

            const handleQrResponse = (response) => {
                if(response !== null) {
                    if(response.startsWith('bankid')|| response.startsWith('https://app.bankid.com')) {
                        setResponseQr(response);
                    }else if(response.startsWith('consentValid')) {
                        const value = response.split("=")[1];
                        CustomReload(`${PUBLIC_PATHS.OPENPAYMENTCOMPLETED}?code=${value}&scope=accountinformationprivate&state=${value}&skip=true`);
                        return;
                    }else{
                        setTimeout(() => {
                            setIsQrResponseError(true);
                        }, 4000);
                        return;
                    }
                }
            };

            try {
                const config = {
                    responseType: 'json',
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${tokenData}`,
                        'Accept-Language': i18next.language || 'en-US'
                    },
                };

                const response = await axios.get( API_URL +"/open-payment/update-qr", config);
                handleQrResponse(response.data);
            } catch (error) {
                FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
            }
        } catch (error) {
            console.error('Error al actualizar el QR:', error);
        }
    };


    const ValidateAccountOpenPayment = async (accountId) => {

        const handleUserSettingsResponse = (responseUserSettings) => {
            if(responseUserSettings !== null) {
                setResponseUserSettings(responseUserSettings);
                $('#validatedAccountButton').prop('disabled', false);
                CustomReload();
            }
        };

        try {
            $('#validatedAccountButton').prop('disabled', true);

            if (accountId !== "") {
                const requestValidatedAccount = {
                    accountId: accountId,
                }

                const apiCallOptions = {
                    method: "put",
                    url: "/usersetting/bank-account/validated",
                    data: requestValidatedAccount,
                };

                try {
                    await ApiCall(apiCallOptions, handleUserSettingsResponse);

                } catch (error) {
                    FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };


    const DeleteIban = async () => {

        const handleUserSettingsResponse = (responseUserSettings) => {
            if(responseUserSettings !== null) {
                setResponseUserSettings(responseUserSettings);
                $('#validatedAccountButton').prop('disabled', false);
                CustomReload();
            }
        };

        try {
            $('#validatedAccountButton').prop('disabled', true);

            const apiCallOptions = {
                method: "delete",
                url: "/usersetting/bank-account/delete",
            };

            try {
                await ApiCall(apiCallOptions, handleUserSettingsResponse);

            } catch (error) {
                console.log(error);
                FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
            }
            
        } catch (err) {
            console.log(err)
        }
    };


    const SubmitData = async () => {
        try {
            $('#submitData').prop('disabled', true);
            setLoading(true); 

            if (bankValue) {
                const apiCallOptions = {
                    method: "get",
                    url: "/open-payment/consent/create?bicFi=" + bankValue,
                };
                try {
                    await ApiCall(apiCallOptions, setConsentResponse);
                } catch (error) {
                    console.log(error);
                     FlashMessage(t('validationMessage.opError'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };

    const handleGroupByDropdownChange = (selectedOption) => {
        if(selectedOption && selectedOption.value) { 
            if (selectedOption.value === 'HANDSESS' || selectedOption.value === 'ELLFSESS') { 
                setBankIdMessage(true);
            }
            else{
                setBankIdMessage(false);
            } 

            $('#submitData').prop('disabled', false);   

            const bancoSeleccionado = banks.find(
                    (b) => b.bicFi === selectedOption.value
                );

            if (bancoSeleccionado) {
                setImgBank(bancoSeleccionado.logoUrl);
            } else {
                setImgBank('');
            }         

            setShowImgBank(true);
            setShowSignButton(true);
            setBankValue(selectedOption?.value);
            return;
        }
        else{
            setShowImgBank(false);
            setShowSignButton(false);
        }
    };    

    // const renderActionColumn = (item) => {
    //     return (
    //         <>             
    //             <CustomButton icon = "bx bx-check py-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4}  buttonColor="#cde0da"  tooltipText={t('button.info')} customClasses="rounded" buttonBorder={false} id='validatedAccountButton' onClick={() => {
    //                          ValidateAccountOpenPayment(item.accountId);   
    //                         }} />
    //         </>
    //     );
    // }

    const modalSendContent = (
        <div id="sendMessageDiv">
            {t('userSetting.deleteIabn')}
        </div>
    );

    const modalSendFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                await DeleteIban();
            }}>
                {t('button.send')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendModal(false)
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalSendQrContent = (
        <>
            <h5 className="text-center mb-5">
                {isMobile
                    ? 'För att fortsätta din process i BankID-applikationen, tryck på knappen nedan.'
                    : 'Logga in med bank-id.'
                }
            </h5>  
            {isMobile ?    
                <Button className="box-green border-0" id="sendButtonQrMobile" onClick={async () => {
                    $('#sendButtonQrMobile').prop('disabled', true);
                    window.open(responseQr, '_blank');
                }}>
                    {"Öppna bankid på den här enheten"}
                </Button>
            :  
                <>
                    <div style={{ height: "auto", margin: "0 auto", maxWidth: 250, width: "100%" }}>
                        <a href={responseQr} target="_blank" rel="noopener noreferrer">
                            <QRCode
                                value={responseQr}
                                size={200}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                viewBox={`0 0 256 256`}
                            />
                        </a>
                    </div>
                    
                    <div className="d-flex justify-content-center">
                        <div>
                            <p className="text-start mb-1 mt-4">1. Öppna BankID-appen och klicka på QR-ikonen.</p>
                            <p className="text-start mb-1 mt-1">2. Rikta kameran mot QR-koden här ovanför. </p>
                        </div>
                    </div>

                </>
            }           
            { isQrResponseError && !isMobile &&(
                <div className="d-flex justify-content-center mt-3 mb-1">
                    <div>
                        <p className="text-center">QR-koden har gått ut.</p>
                        <p className="text-center">Stäng fönstret och försök igen.</p>
                    </div>
                </div>
            )}
        </>
    );

    const modalSendQrFooter = (
        <>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendQrModal(false)
                CustomReload();
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalSendRedirectContent = (
        <>
            <h5 className="text-center">Du omdirigeras nu till din bank.</h5>
            <h5 className="text-center">Vill du gå vidare ?</h5>         
            {displaySpinner ? (
            <>
                <Spinner color='success' className="mt-3 ms-2 me-3" />  
                <h5 className="text-center">Väntar på att processen ska vara klar ...</h5>    
            </>
            ) : null}
        </>
    );

    const modalSendRedirectFooter = (
        <>
            <Button className="box-green border-0" id="sendButtonRedirect" onClick={async () => {
                setDisplaySpinner(true);
                $('#sendButtonRedirect').prop('disabled', true);
                //window.open(consentResponse, '_blank');
                openBankPageWithDetection(consentResponse);
            }}>
                {t('button.continue')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendRedirectModal(false)
                $('#sendButtonRedirect').prop('disabled', false);
                CustomReload();
            }}>{t('button.cancel')}</Button>
        </>
    );


    const modalBeforeShowQr = (
        <>
            <h5 className="text-center">
                Du har valt {bankValue === 'HANDSESS'
                    ? 'Handelsbanken'
                    : bankValue === 'ELLFSESS'
                    ? 'Länsförsäkringar'
                    : bankValue} och vill fortsätta med processen?
            </h5>
        </>
    );

    const modalBeforeShowQrFooter = (
        <>
            <Button className="box-green border-0" id="sendButtonRedirect" onClick={async () => {
                setDisplayBeforeShowQrCode(false)
                await SubmitData();
            }}>
                {t('button.continue')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplayBeforeShowQrCode(false)
            }}>{t('button.cancel')}</Button>
        </>
    );

    const openBankPageWithDetection = (bankUrl) => {     
        const bankWindow = window.open(bankUrl, '_blank');
        
        if (!bankWindow) {
            alert('Vänligen tillåt popup-fönster att fortsätta med kassaprocessen.');
            return;
        }
        
        let hasRedirected = false;
        
        const handleReturn = () => {
            if (!hasRedirected) {
                hasRedirected = true;              
                window.location.reload();
            }
        };
        
        const checkClosed = setInterval(() => {
            if (bankWindow.closed) {
                clearInterval(checkClosed);
                handleReturn();
            }
        }, 1000);
        
        const handleFocus = () => {
            setTimeout(() => {
                if (bankWindow.closed) {
                    clearInterval(checkClosed);
                    window.removeEventListener('focus', handleFocus);
                    handleReturn();
                }
            }, 100);
        };
        
        window.addEventListener('focus', handleFocus);
        
        setTimeout(() => {
            clearInterval(checkClosed);
            window.removeEventListener('focus', handleFocus);
        }, 10 * 60 * 1000);
    };

    const handleMessageReceived = (message) => {
        if(message){
            if(message.text && message.text.includes('Redirect')) {              
                CustomReload();
            }
        }
    };

    
    const customGroupHeading = (props) => {
        const isFirstGroup = props.data?.customIndex === 0;

        if (!isFirstGroup) {
            return (
            <div style={{ borderTop: '1px solid #ccc', margin: '6px 0' }} />
            );
        }

        return null;
    };

    const maskIban = (iban) => {
        if (!iban || iban.length <= 4) {
        return iban;
        }
        const lastFourDigits = iban.slice(-4);
        const maskedSection = '*'.repeat(iban.length - 4);
        return `${maskedSection} ${lastFourDigits}`;
    };

    return(
        <Col lg={12} className='card card-backend px-4 mb-5'>
            <CustomModal isOpen={displaySendModal} toggle={() => setDisplaySendModal(!displaySendModal)} body={modalSendContent} footer={modalSendFooter} />
            <CustomModal isOpen={displaySendQrModal} toggle={() => setDisplaySendQrModal(!displaySendQrModal)} body={modalSendQrContent} footer={modalSendQrFooter}/>
            <CustomModal isOpen={displaySendRedirectModal} toggle={() => setDisplaySendRedirectModal(!displaySendRedirectModal)} body={modalSendRedirectContent} footer={modalSendRedirectFooter}/>
            <CustomModal isOpen={displayBeforeShowQrCode} toggle={() => setDisplayBeforeShowQrCode(!displayBeforeShowQrCode)} body={modalBeforeShowQr} footer={modalBeforeShowQrFooter}/>
            <InformationSignalR onMessageReceived={handleMessageReceived} />
                <Row className="mt-4" style={{overflowX: 'auto'}} >
                    <Col lg='4'>
                        <Row>
                            <Col lg='12'>
                                <h2>Mottagarkonto</h2>                      
                            </Col>
                            <Col lg='12' className="mt-2 mb-2" >
                                <div style={{fontSize: '0.875rem'}}>Utbetalning av dina ersättningar görs till det konto du valt.</div>
                                {/* <div style={{fontSize: '0.875rem', whiteSpace: 'nowrap' }}>Saknar du registrerat konto kan utbetalning inte göras.</div>
                                <div style={{fontSize: '0.875rem', whiteSpace: 'nowrap' }}>Kontonumret hämtar du enkelt direkt från din bank.</div> */}
                                {editModeSettings === false ? 
                                <div className='mt-4 mb-1 d-inline-block mb-0'>       
                                    <h1 className="fw-bold  font-size-18 mb-0">Valt konto:</h1>
                                </div> : null}
                            </Col>
                            {responseUserSettings?.warning && editModeSettings === false && userData?.pnr !== null ? 
                                <Col lg='1' className='text-end'>
                                    
                                        <button  className="rounded me-2 py-2 border-0 text-red bg-transparent p-custom-button position-relative class-approve" >
                                            <i className="bx bx-error pb-custom align-middle size-icon-custom-button" />
                                            <div className="tooltip-custom-button-error-bank-account">
                                                {<pre className="font-size-12">{responseUserSettings?.warning}</pre>}
                                            </div>
                                        </button>
                                        
                                </Col>
                            : ''}
                                {editModeSettings === true &&
                                    <Col xs={12} className="mt-2 mb-3 d-flex justify-content-between align-items-center">
                                        <h1 className="fw-bold font-size-18 mb-0">Ange konto:</h1>
                                        <div className="d-flex gap-2">
                                            <CustomButton 
                                                icon='bx bx-undo py-1' 
                                                iconColor='#EB5757' 
                                                iconSize={5} 
                                                buttonColor='#e9cbcd' 
                                                buttonRadius={3} 
                                                hoverButtonRadius={3} 
                                                hoverIconColor='white' 
                                                hoverButtonColor='#EB5757' 
                                                customClasses="border-0"  
                                                tooltipText={t('button.cancel')} 
                                                onClick={() => { 
                                                    setEditModeSettings(false); 
                                                    setShowEnterManually(false); 
                                                    setShowDropdownBank(true);
                                                }}
                                            />
                                            <CustomButton 
                                                text="" 
                                                icon='bx bx-check py-1' 
                                                iconColor='#157553' 
                                                id='editUserSettings'
                                                iconSize={5} 
                                                buttonColor='#bed1cd'
                                                buttonRadius={3} 
                                                hoverButtonRadius={3}
                                                hoverIconColor='white' 
                                                hoverButtonColor='#157553'
                                                customClasses="border-0"
                                                tooltipText={t('button.save')}
                                                onClick={async () => {
                                                    await EditSettings();
                                                    setCheckClickButton(true);
                                                    setShowDropdownBank(false);
                                                    setShowEnterManually(true);
                                                }}
                                            />
                                        </div>
                                    </Col>
                                }
                        </Row>
                    
                        {editModeSettings === true ? (
                            <Col xs={12} className='mb-4'>
                                <Row className="g-3">
                                    <Col xs={12}>
                                        <CustomInput
                                            model={RequestUserSettingsModel}
                                            attribute='clearingNumber'
                                            data={responseUserSettings?.iban
                                                    ? '' 
                                                    : (responseUserSettings?.clearingNumber || '')
                                            }
                                            customChange={(e) => HandleChange(e, 'clearingNumber')}
                                        />
                                    </Col>

                                    <Col xs={12}>
                                        <CustomInput
                                            model={RequestUserSettingsModel}
                                            attribute='accountNumber'
                                            data={responseUserSettings?.iban
                                                    ? '' 
                                                    : (responseUserSettings?.accountNumber || '')
                                            }
                                            customChange={(e) => HandleChange(e, 'accountNumber')}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        ): null}
                        {userData.pnr && userData.pnr.length === 12 && editModeSettings === false && responseUserSettings !== null && spinnerLoading === false ?                     
                            <Col lg={12} className='text-start mt-1 mb-5'>
                                <div className="d-flex align-items-center gap-4 us-account-summary-row">                                    
                                    {responseUserSettings !== null && !responseUserSettings.iban && responseUserSettings.clearingNumber ?  
                                            <div className='p-3 card card-backend-custom account-card-fit us-account-summary-card'>       
                                                <div className="fw-bold text-green font-size-18">Manuellt registrerat</div>
                                                <div className="text-green fw-bold masked-iban">{maskIban(responseUserSettings.accountNumber)}</div>

                                            </div>
                                    : ''}
                                    {responseUserSettings !== null &&responseUserSettings.iban ?  
                                            <div className='p-3 card card-backend-custom account-card-fit us-account-summary-card'>       
                                                <div className="fw-bold text-green font-size-18">{responseUserSettings.bank}</div>
                                                <div className="text-green fw-bold masked-iban">{maskIban(responseUserSettings.iban)}</div>

                                            </div>
                                    : ''}
                                    {(!responseUserSettings?.clearingNumber || responseUserSettings.clearingNumber.trim() === '') &&
                                    (!responseUserSettings?.iban || responseUserSettings.iban.trim() === '') && (  
                                        <div className='p-3 card card-backend-custom account-card-fit us-account-summary-card'>       
                                        <h1 className="font-size-18 mb-0">Konto saknas</h1>
                                        </div>
                                    )}
                                    <div className="us-account-summary-action">
                                        <CustomButton
                                            text={
                                                (!responseUserSettings?.clearingNumber || responseUserSettings.clearingNumber.trim() === '') &&
                                                (!responseUserSettings?.iban || responseUserSettings.iban.trim() === '')
                                                ? 'Registrera konto'
                                                : 'Ändra'
                                            }
                                            id='submitDatas'
                                            onClick={async () => {                                                
                                                setShowDropdownBank(true);
                                                setShowEnterManually(false);
                                            }}
                                        />
                                    </div>
                                
                                </div>
                            </Col>
                        :                          
                            userData?.pnr === null ? (
                                <div className="text-danger fw-bold">
                                    Användaren har för närvarande ingen kopplad PNR
                                </div>
                            ) : (
                                
                                editModeSettings !== true ? (
                                <div className="d-flex align-items-center">
                                    <Spinner color="success" className="me-2" size="sm" />
                                </div>
                                ) : null
                            )
                        }                  
                        {showDropdownBank && showEnterManually === false ? (
                            <Row className="border border-info-box rounded d-flex align-items-center cursor-pointer-custom p-2 p-md-3 mb-2 mt-3">
                                <Col xs={12} className="mb-3">
                                    <Row className="align-items-center">
                                        <Col xs="auto">
                                            <h6 className="mb-3 mb-md-0 fs-7 fs-md-4">Hämta kontonummer via bank-id</h6>
                                        </Col>

                                        {showImgBank && (
                                            <Col xs="auto">
                                                <img 
                                                    src={imgBank} 
                                                    alt="Logotipo del banco" 
                                                    className="img-fluid"
                                                    style={{ 
                                                        maxHeight: '50px',
                                                        maxWidth: '130px',
                                                        objectFit: 'contain'
                                                    }} 
                                                />
                                            </Col>
                                        )}

                                        <Col xs="auto" className="p-0 ms-auto">
                                            <CustomButton 
                                                icon='bx bx-undo py-1' 
                                                iconColor='#EB5757' 
                                                iconSize={5} 
                                                buttonColor='#e9cbcd' 
                                                buttonRadius={3} 
                                                hoverButtonRadius={3} 
                                                hoverIconColor='white' 
                                                hoverButtonColor='#EB5757' 
                                                customClasses="border-0"  
                                                tooltipText={t('button.cancel')} 
                                                onClick={() => { 
                                                    setShowDropdownBank(false); 
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={showSignButton ? 8 : 8} className="mt-2">
                                    <div className="mb-3">
                                        <div className="row g-2">
                                            <div className="col-12 col-md-8 col-lg-12">
                                                {bankOptions && bankOptions.length > 0 ? (
                                                    <>
                                                        <label className="ms-0 mb-2 d-block">
                                                            {t('userSetting.selectBank')}
                                                        </label>
                                                        <div className="position-relative">
                                                            <Select
                                                                onChange={handleGroupByDropdownChange}
                                                                options={bankOptions}
                                                                placeholder="Ej valt"
                                                                isClearable={true}
                                                                components={{ GroupHeading: customGroupHeading }}
                                                                isSearchable={false}
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                                styles={{
                                                                    control: (provided, state) => ({
                                                                        ...provided,
                                                                        minHeight: '38px',
                                                                        fontSize: '14px',
                                                                        '@media (min-width: 768px)': {
                                                                            fontSize: '16px',
                                                                        },
                                                                    }),
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (provided) => ({
                                                                        ...provided,
                                                                        zIndex: 9999,
                                                                    }),
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    borderRadius: 5,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: 'rgba(21, 117, 83, 0.25)',
                                                                        primary: '#67a58f',
                                                                        neutral0: 'var(--bs-body-bg)',
                                                                        neutral80: 'var(--bs-body-color)',
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="d-flex align-items-center">
                                                        <Spinner color="success" className="me-2" size="sm" />
                                                        <span className="text-muted">Laddar banker...</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                
                                {showSignButton && (
                                    <Col xs={12} lg={4} className="d-flex justify-content-center justify-content-lg-end align-items-center px-2 px-lg-3 mt-2 mt-lg-3">
                                        <div className="d-flex align-items-center w-100 w-lg-auto justify-content-center justify-content-lg-end">
                                            {loading && <Spinner color="success" className="me-2" size="sm" />}
                                            <CustomSubmitButton 
                                                text="Gå vidare" 
                                                id="submitData"
                                                className="w-100 w-lg-auto"
                                                customClick={async () => {
                                                    await SubmitData();
                                                }}
                                            />
                                        </div>
                                    </Col>
                                )}
                                
                                {showDropdownBank && (
                                    <Col xs={12} className="mt-3 pt-2">
                                        <div className="text-center text-lg-start">
                                            <span
                                                role="button"
                                                tabIndex={0}
                                                className="fw-bold text-decoration-underline"
                                                style={{
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                }}
                                                onClick={async () => {
                                                    setShowEnterManually(true);
                                                    setEditModeSettings(true);
                                                    if (
                                                        (responseUserSettings !== null && responseUserSettings.clearingNumber === '') || 
                                                        responseUserSettings === null
                                                    ) {
                                                        await SubmitSettings();
                                                    } else {
                                                        setRequestUserSettings(responseUserSettings);
                                                    }
                                                }}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            >
                                                Eller ange kontonummer manuellt
                                            </span>
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        ) : null}          
                    </Col>
                </Row>                                 
        </Col>
    );
}
